import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const SuccessFilled: React.FC<IIconProps> = ({
  size = IconSizes.md,
  color = 'black',
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 32C24.8367 32 32 24.8367 32 16C32 7.16333 24.8367 0 16 0C7.16333 0 0 7.16333 0 16C0 24.8367 7.16333 32 16 32ZM13.5361 18.8608L10.2739 15.5984L10.2639 15.5889C9.95142 15.2971 9.57593 15.1414 9.15332 15.1414C8.72974 15.1414 8.35742 15.2981 8.05713 15.5984C7.75464 15.9009 7.6001 16.2783 7.6001 16.7068C7.6001 17.1355 7.75464 17.5127 8.05713 17.8152L12.4517 22.2097C12.5159 22.2739 12.584 22.332 12.6562 22.3835C12.7502 22.4509 12.8511 22.5073 12.9585 22.5518C13.1433 22.6277 13.3367 22.6667 13.5356 22.6667C13.7349 22.6667 13.9282 22.6277 14.113 22.5518C14.303 22.4734 14.4722 22.3574 14.6199 22.2097L23.9431 12.8865C24.2456 12.584 24.4001 12.2068 24.4001 11.7781C24.4001 11.3518 24.2471 10.9763 23.948 10.6748C23.6484 10.3564 23.271 10.1897 22.8367 10.2007C22.417 10.2114 22.0486 10.3721 21.7507 10.6697L13.5361 18.8608Z"
        fill={color}
      />
    </svg>
  );
};

export default SuccessFilled;
